import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';

import CircularProgress from '@mui/material/CircularProgress'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import IconButton from '@mui/material/IconButton'
import PaidFormat from 'cityads-v3/components/Format/PaidFormat';
import Payments from './Payments'
import RegionsCollapser from 'cityads-v3/components/Collapser/RegionsCollapser';
import Typography from '@mui/material/Typography'

import {
  getTargets
} from 'cityads-v3/actions/offers';

import classes from './Terms.scss';

@connect(
  (state, props) => ({
    targets        : state.offers.targetsByOfferId[props.offer.id] || [],
    currentLanguage: state.language.language,
  }),
  dispatch => bindActionCreators({
    getTargets,
  }, dispatch)
)
@withTranslation(['Offers'], { i18n, wait: false })
export default class Terms extends Component {

  static propTypes = {
    offer     : PropTypes.object.isRequired,
    targets   : PropTypes.arrayOf(PropTypes.object),
    getTargets: PropTypes.func.isRequired,
  }

  state = {
    offerRegionsExpanded : false,
    offerRegionsTruncated: false,
  }

  componentDidMount() {
    const { offer, targets, getTargets } = this.props;

    if (!targets.length) {
      getTargets(null, offer.id)
    }
  }

  componentDidUpdate(prevProps) {
    const { targets, isStorageCookieOk, currentLanguage, offer, getTargets } = this.props;

    if ((prevProps.isStorageCookieOk !== isStorageCookieOk || prevProps.currentLanguage !== currentLanguage) && targets) {
      // Targets were already loaded && auth status or language has changed
      getTargets(null, offer.id);
    }
  }

  getTargetNames(targets) {
    if (!Array.isArray(targets)) { return [] };
    return [...targets.reduce((acc, target) => acc.add(target.text), new Set())];
  }

  toggleOfferRegionsExpanded = evt => {
    this.setState(({ offerRegionsExpanded, offerRegionsTruncated }) => ({
      offerRegionsExpanded: !offerRegionsExpanded,
      // if collapser was expanded, set that it is now truncated right away to avoid glitching of collapser button
      offerRegionsTruncated: offerRegionsExpanded ? true : offerRegionsTruncated,
    }));
  }

  setOfferRegionsTruncated = truncated => {
    if (this.state.offerRegionsTruncated !== truncated) {
      this.setState({ offerRegionsTruncated: truncated });
    }
  }

  render() {
    const { t, offer, targets } = this.props;
    const { offerRegionsExpanded, offerRegionsTruncated } = this.state;

    return (
      <div>
        <table className={classes.options}>
          <tbody>
            <tr>
              <td className={classes.options__title}>{t('payment')}:</td>
              <td className={classes.options__value} data-term-value="payment">
                <PaidFormat commissionData={offer.commission_data} precision={2} />
              </td>
            </tr>
            <tr>
              <td className={classes.options__title}>{t('offerTarget')}:</td>
              <td className={classes.options__value} data-term-value="target">
                {(!targets || targets.isLoading) ?
                  <CircularProgress size={12} /> :
                  this.getTargetNames(targets).join(', ')
                }
              </td>
            </tr>
            <tr>
              <td className={classes.options__title}>{t('regions')}:</td>
              <td className={classes.options__value} data-term-value="regions">
                <div className={classes.regionsContainer}>
                  {offer.regions?.length ?
                    (
                      <div>
                        <RegionsCollapser
                          ids        = {offer.regions}
                          lines      = {2}
                          expanded   = {offerRegionsExpanded}
                          onTruncate = {this.setOfferRegionsTruncated}
                        />
                      </div>
                    ) :
                    t('worldwide')
                  }
                  {(offerRegionsTruncated || offerRegionsExpanded) ?
                    (
                      <IconButton
                        className = {classNames(classes.expandButton, classes.expandOfferRegionsButton, { [classes.expandButtonExpanded]: offerRegionsExpanded })}
                        onClick={this.toggleOfferRegionsExpanded}
                        size="large"
                      >
                        <ExpandMoreIcon />
                      </IconButton>
                    ) :
                    null
                  }
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <Typography component="div" className={classes.subtitle}>{t('payments')}</Typography>

        <Payments targets={targets} />
      </div>
    );
  }

}
